export default {
  selection: "Chọn Ngôn Ngữ Hệ Thống",
  english: "English",
  simplified_chinese: "中文 （简体）",
  list: {
    en: "Tiếng Anh",
    zh: "Tiếng Trung (CN)",
    tw: "Tiếng Trung (TW)",
    vi: "Tiếng Việt",
    th: "Tiếng Thái",
    id: "Tiếng Indonesia",
    malay: "Tiếng Mã Lai",
    jp: "Tiếng Nhật",
    kr: "Tiếng Hàn",
    my: "Myanmar",
    ar: "Argentina",
    ru: "Nga",
    ne: "Người Nepal",
    bn: "Tiếng Bangla"
  }
};
